import {BranchesOutlined, FileTextOutlined, TableOutlined, TeamOutlined} from "@ant-design/icons";
import {ConfigProvider, Menu} from "antd";
import {NavLink} from "react-router-dom";
import {RoutingPaths} from "../../routing/routingContainer";
import styles from "./siderMenu.module.less"
import {useCurrentRoutingPath} from "digimuth-components/dist";
import useCurrentUserRoles from "../../../hooks/useCurrentUserRoles";
import { mainColor } from "../../../App";

export default function SiderMenu() {
    const route = useCurrentRoutingPath(RoutingPaths)?.route || "";
    const userRoles = useCurrentUserRoles();

    const siderDefaultTheme = {
        token: {
            borderRadius: 0
        },
        components: {
            Menu: {
                itemBg: "#FFFFFF",
                itemSelectedColor: mainColor,
                itemSelectedBg: "#FFFFFF",
            }
        }
    }

    return <ConfigProvider theme={siderDefaultTheme}>
        <div className={styles.sideMenuWrapper} data-testid="sider-menu-wrapper">
            <Menu selectedKeys={[route]} mode="inline" data-testid="sider-menu">
            <Menu.Item key={RoutingPaths.announcementTable.route} icon={<FileTextOutlined />} data-testid="menu-item-announcement">
                <NavLink to={RoutingPaths.announcementTable.route} data-testid="navlink-announcement">
                Powiadomienia
                </NavLink>
            </Menu.Item>
            {(userRoles?.includes("prepare:announcements") && userRoles?.includes("review:announcements"))
                && <Menu.Item key={RoutingPaths.userTable.route} icon={<TeamOutlined />} data-testid="menu-item-user">
                <NavLink to={RoutingPaths.userTable.route} data-testid="navlink-user">
                    Użytkownicy
                </NavLink>
                </Menu.Item>
            }
            {(userRoles?.includes("prepare:announcements") && userRoles?.includes("review:announcements"))
                && <Menu.Item key={RoutingPaths.categoryTable.route} icon={<BranchesOutlined />} data-testid="menu-item-category">
                <NavLink to={RoutingPaths.categoryTable.route} data-testid="navlink-category">
                    Kategorie
                </NavLink>
                    </Menu.Item>
                }
            </Menu>
        </div>
    </ConfigProvider>;
}
